"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HomeIcon = HomeIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function HomeIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.6 3.45C12.2444 3.18333 11.7556 3.18333 11.4 3.45L4.4 8.7C4.14819 8.88885 4 9.18524 4 9.5V20C4 20.5523 4.44772 21 5 21H8C8.55228 21 9 20.5523 9 20V15C9 14.4477 9.44772 14 10 14H14C14.5523 14 15 14.4477 15 15V20C15 20.5523 15.4477 21 16 21H19C19.5523 21 20 20.5523 20 20V9.5C20 9.18524 19.8518 8.88885 19.6 8.7L12.6 3.45Z",
    fill: "currentColor"
  }));
}